export const executeDownload = (url: string) => {
  const link = document.createElement("a");
  link.href = url;
  link.style.display = "none";
  document.body.appendChild(link);

  if (/iPhone|iPad/.test(navigator.userAgent)) {
    // for iOS devices, trigger the download on click
    link.addEventListener("click", () => {
      link.setAttribute("download", url.split("/")?.pop() ?? "");
      link.click();
      document.body.removeChild(link);
    });
    link.click();
  } else {
    // for other platforms, open the PDF in a new tab
    link.target = "_blank";
    link.download = url.split("/").pop() ?? "";
    link.click();
    document.body.removeChild(link);
  }
};
